import React from 'react';
import { Button, Modal, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isNameValid } from 'services/Validation';

class AddSurveyGroup extends React.Component {
    constructor(props) {
        super(props);

        const { id, thumb, name, selected, starred, frequently } = props.surveyGroup;
        this.state = {
            id,
            thumb,
            name,
            selected,
            starred,
            frequently,
            nameValid: isNameValid(name),
            formErrors: { name: '' },
            formValid: false
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value) } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;

        switch (fieldName) {
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.nameValid });
    }

    render() {
        const { onSaveSurveyGroup, showSurveyGroupLoader, onSurveyGroupClose, open, surveyGroup } = this.props;
        const { name, selected, starred, frequently } = this.state;
        const isNew = surveyGroup.name === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onSurveyGroupClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="surveyGroup.addSurveyGroup" /> :
                        <IntlMessages id="surveyGroup.saveSurveyGroup" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onSurveyGroupClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={thumb} />
                        </div>

                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>

                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <input type="text" className="form-control mb-2"
                                placeholder="Survey Group Name"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showSurveyGroupLoader();
                        onSurveyGroupClose();
                        onSaveSurveyGroup(
                            {
                                'name': name,
                                'thumb': null,
                                'selected': selected,
                                'starred': starred,
                                'frequently': frequently,
                            });
                        this.setState({
                            name: '',
                            thumb: null,
                            selected: false,
                            starred: false,
                            frequently: false,
                            formErrors: { name: '' },
                            formValid: false
                        });
                    }}>
                        {isNew ? <IntlMessages id="surveyGroup.addSurveyGroup" /> :
                            <IntlMessages id="surveyGroup.saveSurveyGroup" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default AddSurveyGroup;


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroup/AddSurveyGroup/index.js